import React, {useEffect} from 'react';
import _ from 'lodash';
import ChatInfoSaver from "./ChatInfoSaver";
import CatchErrors from "../Utility/CatchErrors";
import ErrorModal from "./ErrorModal";
import scrapyardSlice from "../ReduxStore/scrapyardSlice";
import FancyboxContainer from "./FancyboxContainer";
import KlaviyoInformant from "../Klaviyo/KlaviyoInformant";
import RemoveStashedUser from "./RemoveStashedUser";
import ActivateComponentTags from "./ActivateComponentTags";
import ShadedOverlay from "./ShadedOverlay";
import PageTriggerInvoker from "./PageTriggerInvoker";
import HiddenModalActivator from "../Modals/HiddenModalActivator";
import DataLayerSpy from "./DataLayerSpy";

const isDev = (process.env.NODE_ENV == 'development');

export default function EyeInTheSky({
  chatInfo, error, dispatch, currentAgent, customerVehicle, railsContext,
  controllerName, actionName,
  userStore = {},  // from redux userSlice
  shoppingCart,
  navigationSlice = {},
  pageTimes, pageCount, // 2025-04 scrapyardSlice
  sessionFacts = {}, // 2025-08
  ...props
}) {
  // cartOverview, cart, scrapyard, dispatch, controllerName, actionName
  const cartCode = extractCartCode(props);
  const { currentParams={} } = (sessionFacts || {});

  // 2024-03 set current agent into redux on startup
  useEffect(() => {
    dispatch(scrapyardSlice.actions.setItems({currentAgent}));
  }, []);

  // error = { message: "This is a fake error"}

  //let debugMode = !!currentParams['KWYJIBO'];

  // Do NOT put presentation classes on the top level div.
  // do NOT put .relative on the top level div, it will break ShadedOverlay
  return (
    <div className="text-pencil bg-paper">
      <CatchErrors>
        <ShadedOverlay dispatch={dispatch} overlays={navigationSlice?.overlays}/>
      </CatchErrors>

      <CatchErrors>
        <ChatInfoSaver cartCode={cartCode} chatInfo={chatInfo} dispatch={dispatch}/>
      </CatchErrors>

      <CatchErrors>
        <FancyboxContainer bindTargets="fancybox"/>
      </CatchErrors>

      <CatchErrors>
        <ActivateComponentTags/>
      </CatchErrors>

      <CatchErrors>
        <HiddenModalActivator/>
      </CatchErrors>

      <CatchErrors><PopupWatcher status={props.popupOpen}/></CatchErrors>

      {currentAgent && <CatchErrors>
        <RemoveStashedUser
          currentAgent={currentAgent}
          cartCode={cartCode}
          customerVehicle={customerVehicle}
          controllerName={controllerName}
          user={userStore?.emailUser}
        />
      </CatchErrors>}

      {!currentAgent && <CatchErrors>
        <KlaviyoInformant
          cartCode={cartCode}
          customerVehicle={customerVehicle}
          controllerName={controllerName}
          user={userStore?.emailUser}
          shoppingCart={shoppingCart}
          navigationSlice={navigationSlice}
        />
      </CatchErrors>}

      {!currentAgent &&
        <CatchErrors>
          <PageTriggerInvoker pageTimes={pageTimes} pageCount={pageCount}
            navigationSlice={navigationSlice}
            sessionFacts={sessionFacts} />
        </CatchErrors>
      }


      {error && error.message && <ErrorModal dispatch={dispatch} error={error}/>}
    </div>
  );
}

function extractCartCode({cartOverview = {}, cartSlice = {}}) {
  const {shoppingCart} = (cartSlice || {});

  let cc = shoppingCart && shoppingCart.cartCode;
  if (cc)
    return cc;

  return cartOverview && cartOverview.cartCode;
}

function PopupWatcher({status}) {
  if (!status) return null;
  if (!isDev) return null;

  return (
    <div className="fixed right-0 bottom-0 bg-green-800 text-white"
      style={{zIndex: 1_000_000}}>
      {JSON.stringify(status)}
    </div>
  );
}
